import { CustomIcon } from 'modules/components/layer00';
import { InformationModalLayout } from 'modules/components/layer13';
import React from 'react';
import * as ds from './dataService';



export type DeleteFolderModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: DeleteFolderModalProps) => {
  const [
    fnDeleteFolder,
    { loading }
  ] = ds.useDeleteFolder();



  return (
    <InformationModalLayout.FC
      id={props.id}
      isVisible={props.isVisible}
      loading={loading}
      handleClose={() => props.handleClose()}
      title='Remove Folder'
      headerIcon={(
        <CustomIcon.large.FC
          icon='DELETE'
        />
      )}
      subTitle='Are you sure to remove folder? This action cannot be undone.'
      successButton={{
        text: 'Confirm',
        handleClick: async () => {
          await fnDeleteFolder(props.id);
          props.handleClose();

        }
      }}
      cancelButton={{
        text: 'Cancel',
        handleClick: () => props.handleClose()
      }}
    />
  );
};
